import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.adminAuth;

export const isLoadingAdminLoginSelector = createSelector(
  getState,
  (state) => state.isLoadingAdminLogin,
);

export const adminDataSelector = createSelector(getState, (state) => state.adminData);
export const adminSessionSelector = createSelector(getState, (state) => state.adminSession);
export const isLoadingAdminSessionSelector = createSelector(
  getState,
  (state) => state.isLoadingAdminSession,
);
